import ImageView from 'Components/Image/ImageView';
import React from 'react';
import StyleCard from './TemplateCard.module.scss';
const TemplateCard = ({
  selected,
  onClick,
  id,
  className,
  ImageSrc,
  imageStyle,
  heading,
  text,
}) => {
  return (
    <div className="template-card">
      <div
        className={
          StyleCard.TemplateCardWrapper +
          `${selected === id ? ' active ' : ''}`
        }
        onClick={onClick}
      >
        <div className={StyleCard.cardHeader}>
          <div className={`${StyleCard[className]} ` + StyleCard.ImageSection}>
            <ImageView src={ImageSrc} style={imageStyle} />
          </div>
          <p className={StyleCard.cardHeadingText}>{heading}</p>
        </div>
        <p className={StyleCard.cardDetailsText}>{text}</p>
      </div>
    </div>
  );
};

export default TemplateCard;
